import React from "react";
import { useStore } from "../../store";
import PropTypes from "prop-types";
import { Wrapper, EndorsersLogo, EndorserLabel } from "./_styled";

const AboutTabEndorsersRow = ({ endorser }) => {
  const { contributorLogos } = useStore();
  const endorserId = endorser?.id?.toLowerCase();

  if (!endorserId || !contributorLogos[endorserId]) {
    return null;
  }

  return (
    <Wrapper data-testid="endorser-row">
      <EndorserLabel
        element="p"
        fontSize="sm"
        data-testid="endorser-description"
      >
        <span dangerouslySetInnerHTML={{ __html: endorser.description }} />
      </EndorserLabel>
      <EndorsersLogo
        data-testid="endorser-logo"
        data-endorser-id={endorserId}
        src={contributorLogos[endorserId]?.src}
        alt={contributorLogos[endorserId]?.alt}
      />
    </Wrapper>
  );
};

AboutTabEndorsersRow.propTypes = {
  endorser: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
};

AboutTabEndorsersRow.displayName = "AboutTabEndorsersRow";
export default AboutTabEndorsersRow;
